export const dataPerguntas = [
  {
    id: 1,
    title: `Quais são os canais de atendimento ao cliente?`,
    text: `<p>Você pode falar com a gente pelo WhatsApp no (21) 99025-7203, pelo chat online (basta clicar no ícone de atendimento aqui ao lado) ou por e-mail no atendimento.servicos@cidadaniaja.com.br.</p>
    <p>Nosso horário de atendimento é de segunda a sexta, das 09h às 17h (exceto feriados). Mensagens enviadas fora deste horário serão respondidas no próximo dia útil.</p>`,
  },
  {
    id: 2,
    title: `O que é o alinhamento inicial do serviço?`,
    text: `<p>O alinhamento inicial é um momento importante para garantir que tudo fique claro desde o começo! Nele, esclarecemos dúvidas sobre documentação, prazos e os procedimentos contratados.</p>
    <p>Embora não seja obrigatório, recomendamos que você participe para entender melhor cada etapa do processo.</p>
    <p>Essa fase é voltada para novos clientes, mas se você já passou pelo alinhamento e tem alguma dúvida específica, é só entrar em contato pelos nossos canais de atendimento.</p>
    <p>Estamos aqui para ajudar!</p>`,
  },
  {
    id: 3,
    title: `Como faço o alinhamento inicial?`,
    text: `<p>Se quiser rever seu alinhamento virtual, é só acessar a aba de tutoriais clicando aqui.</p>
    <p>Caso ainda tenha alguma dúvida que não foi abordada, você pode agendar um novo alinhamento com uma de nossas agentes através do link abaixo:</p>
    <p><a href="https://cidadaniaja.pipedrive.com/scheduler/EMjBKS9v/reuniao-de-alinhamento">https://cidadaniaja.pipedrive.com/scheduler/EMjBKS9v/reuniao-de-alinhamento</a></p>
    <p>Estamos à disposição para te ajudar!</p>`,
  },
  {
    id: 4,
    title: `Como funciona a confirmação do recebimento de documentos no nosso escritório?`,
    text: `<p>O setor de documentação confirma o recebimento por e-mail em até 72 horas úteis após a chegada dos documentos ao escritório. Se a entrega for feita em uma de nossas lojas, o prazo para que os documentos cheguem ao escritório é de até 10 dias.</p>
    <p>Assim que o recebimento for confirmado, você poderá visualizar os documentos na etapa de documentação. Caso não receba a confirmação dentro do prazo, entre em contato conosco para verificarmos.</p>`,
  },
  {
    id: 5,
    title: `Preciso entregar os documentos físicos para o meu procedimento?`,
    text: `<p>Sim! Todos os documentos precisam ser entregues fisicamente, dentro do prazo de validade e em suas versões originais. Somente assim eles serão válidos em Portugal.</p>`,
  },
  {
    id: 6,
    title: `Para qual endereço devo enviar os documentos?`,
    text: `<p>Depois de reunir todos os documentos solicitados pela nossa equipe, envie para o endereço do nosso escritório:</p>
    <p><strong>Endereço: Praia de Botafogo, 518 – 10º andar (frente)</strong><br />
    <strong>Rio de Janeiro – CEP 22250-040</strong></p>`,
  },
  {
    id: 7,
    title: `Quando posso entregar os documentos presencialmente?`,
    text: `<p>Os atendimentos presenciais são realizados <b>segundas e quintas-feiras</b>, das <b>09h00 às 17h00</b>. O agendamento deve ser solicitado por meio dos nossos canais de atendimento via <b>WhatsApp</b> ou <b>e-mail</b>.</p>
    <p><b>Finais de semana e feriados nacionais:</b> Fechado.</p>
    <p><b>Endereço:</b></p>
    <p>Praia de Botafogo, 518 – 10º andar (frente)</p>
    <p>Rio de Janeiro – RJ - CEP: 22250-040</p>
    <p>Após a entrega da documentação, nossa equipe realizará a conferência e você receberá a confirmação em <b>até 72 horas úteis</b>, por e-mail e também pela Central do Cliente.</p>
    <p>Como alternativa, você também pode realizar a entrega da documentação nas lojas da Cidadania Já localizadas no <b>Barra Shopping</b> e no <b>RioSul</b>, dentro do horário de funcionamento dos respectivos shoppings.</p>`
  },
  {
    id: 8,
    title: `Preenchi o formulário do meu pedido, mas não encontrei minha procuração. O que fazer?`,
    text: `<p>Depois de preencher o formulário, a procuração fica disponível para download no mesmo item onde você clicou para acessá-lo.</p>
    <p>Além disso, também enviamos a procuração por e-mail em formato PDF, pronta para impressão e reconhecimento por autenticidade no cartório.</p>
    <p>Atenção: não pode ser reconhecimento por semelhança!</p>
    <p>Se não encontrar, verifique sua caixa de spam ou entre em contato com a gente.</p>`,
  },
  {
    id: 9,
    title: `Posso usar o mesmo documento em mais de um processo?`,
    text: `<p>Não. Cada processo é analisado separadamente por Portugal, e é necessário enviar uma via física original atualizada para cada pedido.</p>`,
  },
  {
    id: 10,
    title: `Vocês pedem a certidão de nascimento de alguém que se casou e não tem certidão de nascimento em mãos, ficou retida no cartório. O que eu faço?`,
    text: `<p>Se você se casou e não tem mais a sua certidão de nascimento em mãos porque ela ficou no cartório, não se preocupe. Quando ocorre um casamento, uma via da certidão de nascimento realmente fica retida no cartório de casamento, mas o registro original permanece no cartório onde o nascimento foi feito. Basta solicitar diretamente para o cartório a nova via no formato indicado na listagem dos documentos!</p>`,
  },
  {
    id: 11,
    title: `Qual a validade das certidões?`,
    text: `<p>- Inteiro teor digitada: 6 meses.<br />
    - Reprográfica: 1 ano.</p>`,
  },
  {
    id: 12,
    title: `Meu documento de identificação precisa ter sido emitido recentemente?`,
    text: `<p>Sim! Para os pedidos de cidadania portuguesa, o documento de identificação (como RG ou passaporte) precisa ter sido emitido há no máximo 5 anos. Documentos com foto mais antigos podem ser recusados pelas autoridades portuguesas.</p>`,
  },
  {
    id: 13,
    title: `Só tenho documento militar ou profissional, ele serve para o meu processo?`,
    text: `<p>Para os pedidos de cidadania portuguesa, infelizmente não são aceitos documentos profissionais ou militares como identificação civil. Isso inclui carteiras da OAB, CRP, CRM, carteiras de servidor público, documentos militares, entre outros.</p>`,
  },
  {
    id: 14,
    title: `Posso enviar a cópia do meu documento português ao invés de RG, passaporte ou CNH?`,
    text: `<p>Sim, é possível utilizar o Cartão de Cidadão português como documento de identificação.</p>`,
  },
  {
    id: 15,
    title: `Como reconhecer firma e autenticar documento de identificação do meu pedido no exterior?`,
    text: `<p>Se você está em Portugal, pode reconhecer a firma da procuração em qualquer cartório de notas português ou com um advogado com inscrição na Ordem dos Advogados de Portugal.</p>
    <p>Se estiver em outro país que não seja Brasil ou Portugal, a regra muda um pouco. Nesse caso, a procuração precisa ser reconhecida no Consulado de Portugal.</p>`,
  },
  {
    id: 16,
    title: `Como reconhecer a procuração por autenticidade?`,
    text: `<p>O reconhecimento de assinatura por autenticidade é feito exclusivamente de forma presencial no cartório. Você precisa levar a procuração impressa (sem preencher ou assinar), assinar e datar na presença do tabelião e solicitar que o reconhecimento seja feito por autenticidade. Depois é só conferir se o selo colado é realmente de “autenticidade/verdadeiro” (não pode ser o de semelhança)!</p>`,
  },
  {
    id: 17,
    title: `Ao tentar emitir uma certidão junto ao cartório, fui informado que ela está destruída. E agora?`,
    text: `<p>Com o passar dos anos, é possível que os livros de registro do cartório sofram danos, como rasgos, manchas, perda de legibilidade ou até acidentes como mofo e incêndio. Nesse caso, o cartório é obrigado por lei a restituir o registro danificado em um novo livro, gerando o que chamamos de registro restituído. Essa nova versão tem validade legal no Brasil, mas não é aceita pelas conservatórias em Portugal (para pedidos de cidadania portuguesa, mas para atualização de estado civil vale).</p>`,
  },
  {
    id: 18,
    title: `O que acontece após o recebimento da documentação?`,
    text: `<p>Depois que você recebe o e-mail de confirmação do recebimento da documentação, ela passa por uma análise interna para garantir que todos os documentos estejam dentro dos formatos exigidos pelas conservatórias em Portugal.</p>
    <p>Essa análise é essencial para identificar possíveis inconsistências e evitar problemas após o envio para Portugal.</p>
    <p>Se houver alguma pendência ou necessidade de ajuste, entraremos em contato com as orientações necessárias.</p>`,
  },
  {
    id: 19,
    title: `O que é o Apostilamento de Haia?`,
    text: `<p>O Apostilamento de Haia é um certificado que confirma a validade de um documento público para uso em outro país.</p>
    <p>No Brasil, ele é feito em cartório e garante que seus documentos possam ser aceitos oficialmente em Portugal. O apostilamento é emitido em papel moeda, com a assinatura, o cargo do agente público e o selo ou carimbo da instituição.</p>`,
  },
  {
    id: 20,
    title: `Quanto tempo demora para fazer o apostilamento dos documentos?`,
    text: `<p>O apostilamento é feito em cartório e essa etapa demora até 2 semanas para retorno.</p>`,
  },
  {
    id: 21,
    title: `O que acontece após o apostilamento?`,
    text: `<p>Assim que recebemos os documentos apostilados do cartório, iniciamos os preparativos para o envio do seu processo a Portugal.</p>
    <p>Se já tivermos em mãos o assento ou registro de batismo do português da família, seguimos com as seguintes etapas:</p>
    <ul style="list-style: inside; font-size: 17px; line-height: 1.75rem; color: var(--cinza-80);">
      <li>Reanálise da documentação reunida</li>
      <li>Pagamento dos emolumentos exigidos pelo órgão responsável em Portugal</li>
      <li>Preenchimento e organização dos formulários do pedido</li>
      <li>Envio dos documentos via transportadora DHL</li>
    </ul>
    <p>Assim que o envio for realizado, você receberá um e-mail com a confirmação e o código de rastreio da DHL.</p>
    <p>Importante: O código de rastreio da DHL expira pouco tempo depois da entrega, pois a empresa reutiliza o mesmo código em outras remessas.</p>`,
  },
  {
    id: 22,
    title: `Quanto tempo demora para o órgão público finalizar o pedido após o envio?`,
    text: `<p>O tempo estimado que cada procedimento leva, baseado em casos passados, é de:</p>
    <ul style="list-style: inside; font-size: 17px; line-height: 1.75rem; color: var(--cinza-80);">
      <li>Atribuição de cidadania para filhos: 24 a 42 meses</li>
      <li>Menor de idade (filho): 12 a 24 meses</li>
      <li>Atribuição de cidadania para netos: 36 a 60 meses</li>
      <li>Atribuição de cidadania de menor de idade: 12 a 24 meses</li>
      <li>Aquisição de cidadania para cônjuge de portugueses: 36 a 60 meses</li>
      <li>Transcrição de casamento: 12 a 24 meses</li>
      <li>Homologação de Divórcio ou de União Estável: 18 a 24 meses</li>
    </ul>`,
  },
  {
    id: 23,
    title: `Como eu acompanho o andamento e etapas do meu pedido em Portugal?`,
    text: `<p>Você pode acompanhar o andamento do seu pedido diretamente na sua central do cliente, acessando o “Passo 6 - Andamento”, dentro da área “Meus Pedidos”. Por lá, você encontra a perspectiva de conclusão do processo e o tempo que já se passou desde o envio da sua documentação. Além disso, sempre que tivermos atualizações importantes, iremos enviar para o seu e-mail cadastrado com a gente.</p>`,
  },
  {
    id: 24,
    title: `Eu não recebi a minha senha de acesso para consulta no site do governo português!`,
    text: `<p>A senha de consulta é gerada diretamente pela Conservatória em Portugal, e o prazo para que isso aconteça costuma variar. Em média, ela costuma ser emitida entre seis a oito meses após a entrada do pedido no órgão.</p>
    <p>No seu caso, como o processo foi enviado com uma procuração para a nossa advogada parceira, é ela quem recebe essa senha. Assim que for disponibilizada, nós encaminharemos para você por e-mail.</p>`,
  },
  {
    id: 25,
    title: `Surgiu um obstáculo no tratamento da minha documentação, como posso tirar dúvidas a respeito disso?`,
    text: `<p>Caso apareça algum obstáculo na análise da sua documentação, você será avisado pela central do cliente, e a nossa equipe especialista entrará em contato com você pelo e-mail cadastrado em até 72 horas.</p>`,
  },
  {
    id: 26,
    title: `O que acontece ao concluir o procedimento de cidadania?`,
    text: `<p>Após a finalização do pedido de aquisição ou atribuição, você se torna oficialmente um cidadão português. Com isso, é gerado o número de assento, que funciona como o seu registro civil em Portugal — o equivalente à certidão de nascimento no Brasil.</p>
    <p>Esse número é fundamental, pois é a partir dele que você poderá realizar todos os próximos passos como cidadão português, como:</p>
    <ul style="list-style: inside; font-size: 17px; line-height: 1.75rem; color: var(--cinza-80);">
      <li>Solicitar o Cartão de Cidadão e o passaporte europeu no consulado</li>
      <li>Transmitir a cidadania para filhos ou netos, se for o caso</li>
      <li>Averbar casamento ou divórcio em Portugal</li>
      <li>Iniciar qualquer outro procedimento legal ligado à sua cidadania</li>
    </ul>
    <p>O número do assento é enviado por e-mail, em formato digital, com validade legal em Portugal. Para os próximos passos, não é necessário ter uma versão física — o documento digital é suficiente.</p>
    <p>Importante: Todo cidadão português deve manter o seu estado civil atualizado em Portugal. Se você já é cidadão, mas ainda não reconheceu oficialmente o casamento (ou divórcio) por meio da transcrição, pode enfrentar dificuldades para emitir documentos no consulado. Por isso, recomendamos que regularize seu estado civil em Portugal o quanto antes.</p>`,
  },
  {
    id: 27,
    title: `Como emitir o cartão cidadão e o passaporte?`,
    text: `<p>A emissão do Cartão de Cidadão e do Passaporte português é feita presencialmente, com o próprio requerente, e segue uma ordem obrigatória: primeiro é necessário emitir o Cartão de Cidadão e, somente após tê-lo em mãos, é possível solicitar o Passaporte. Esses documentos podem ser emitidos em qualquer consulado de Portugal no Brasil ou em outros países, além das Lojas do Cidadão, em território português, que também realizam esse serviço.</p>
    <p>Para agendar a emissão, é necessário entrar em contato com o consulado da sua região — em muitos casos, o agendamento pode ser feito online, diretamente pelo site do consulado.</p>
    <p>Junto com o e-mail de conclusão do seu processo de cidadania, você também receberá um guia com orientações detalhadas sobre como realizar cada etapa desse procedimento.</p>`,
  },
  {
    id: 28,
    title: `Uma pessoa tendo cidadania portuguesa, precisa de algum procedimento para reagrupar o cônjuge?`,
    text: `<p>Sim! Para que o cônjuge possa residir legalmente em Portugal por meio do reagrupamento familiar, é necessário que o cidadão português atualize seu estado civil em Portugal, realizando a transcrição do casamento.</p>`,
  },
  {
    id: 29,
    title: `Existe fila prioritária para pedidos de cidadania em Portugal?`,
    text: `<p>De forma geral, os pedidos seguem a ordem de entrada. Existe uma exceção são os processos de pessoas com 75 anos ou mais que deram entrada até o ano de 2023 e para pessoas que dependem da cidadania para trabalhar ou estudar fora — nesses casos, há sim tratamento prioritário.</p>`,
  },
  {
    id: 30,
    title: `Quais documentos precisam ser solicitados para os pedidos de prioridade?`,
    text: `<p>Para quem pretende estudar ou trabalhar, é necessário apresentar uma declaração oficial da instituição de ensino ou da empresa que comprove a urgência na obtenção da cidadania. Já para pessoas idosas, o tratamento prioritário é concedido automaticamente.</p>`,
  },
];
